import React from 'react';

/**
 * @typedef {object} AppraisalSamplingDetailsProps
 * @property {Array<Object>} [appraisalUnits]
 */

/**
 * @param {AppraisalSamplingDetailsProps} props
 */
const AppraisalSamplingDetails = props => {
  const { appraisalUnits = [] } = props;

  return (
    <>
      {appraisalUnits.map(orgUnit => (
        <span key={orgUnit.Id}>
          <strong>{orgUnit.Name}: </strong>
          {orgUnit.AppraisalOrgUnitProjects.length ? (
            <ul className='no-margin'>
              {orgUnit.AppraisalOrgUnitProjects.map(simple => (
                <li key={simple.Id} data-testid='sampling-details'>
                  <strong>{simple.Name}</strong>: {simple.Description || 'N/A'}
                </li>
              ))}
            </ul>
          ) : (
            <p data-testid='no-data'>N/A</p>
          )}
        </span>
      ))}
    </>
  );
};

export default AppraisalSamplingDetails;
